<template>
  <section class="md:mb-8 lg:mb-16">
    <categories />

    <!-- product list -->
    <items-header />
    <items />
  </section>
</template>

<script>
import { watch } from 'vue'

import Items from '@/components/search/SearchItemsProducts.vue'
import Categories from '@/components/search/SearchCategories.vue'
import ItemsHeader from '@/components/search/SearchItemsHeader.vue'

import router from '@/compositions/products/ProductRouter'
import searchQueryState from '@/compositions/search/SearchQuery'
import searchConfig from '@/compositions/search/SearchConfiguration'
import routerHelper from '@/compositions/search/SearchRouterHelper'
import searchFactory from '@/compositions/search/SearchFactory'

export default {
  router,
  components: {
    Categories,
    Items,
    ItemsHeader
  },
  props: {
    searchConfiguration: {
      type: Object,
      required: true
    },
    language: {
      type: String,
      required: true
    },
    baseUrl: {
      type: String,
      required: true
    },
    initialSearchResult: {
      type: Object,
      default: null
    }
  },
  setup(props) {
    searchConfig.searchConfigurationUse([props.searchConfiguration])
    const { getRouteData, updateRoute } = routerHelper.useRouterHelper(router, props.baseUrl)
    const routeData = getRouteData(router)
    routeData.language = props.language
    routeData.itemsCount = routeData.itemsCount || props.initialSearchResult?.items?.length

    searchQueryState.searchQueryUse(routeData)
    searchFactory.initialize(props.initialSearchResult)
    const { loading } = searchFactory.useSearchResult()

    watch(
      () => [loading.value],
      () => {
        if (!loading.value) {
          updateRoute()
        }
      }
    )
    return {
      loading,
      routeData
    }
  }
}
</script>
